import React from 'react';
import InternalNav from '../common/InternalNav';
import { __ } from '../../Lang.js';

const GuestHero = ({ isLoggedIn }) => {
  return (
    <section className="hero">
      <div className="hero__background">
        <div className="hero__logo-bg"></div>
        <video
          autoPlay
          muted
          loop
          playsInline
          className="hero__video-bg"
        >
          <source
            src="https://now.cdn.msia.org/3259/TWI/twi_hero.mp4"
            type="video/mp4"
          />
        </video>
        <div className="hero__overlay"></div>
        
      </div>

     <div className="guest-internal-nav">
      <InternalNav isLoggedIn={isLoggedIn} />
      </div>


      <div className="hero__content">
        <h1
          className="hero__title"
          dangerouslySetInnerHTML={{
            __html: __('Explore the Path<br>of Soul Transcendence'),
          }}
        />
      </div>
    </section>
  );
};

export default GuestHero;